export default __webpack_public_path__ + "static/media/search-grey.a9d24b72.svg";